import React from 'react'
import { Button } from '@mui/material'
import ConfirmationDialog from 'src/legacy/components/mui/ConfirmationDialog'
import useScrollToFirstError from './useScrollToFirstError'

type Props = {
  isSubmitting: boolean
  onSubmit: () => void
  buttonLabel?: string
  dialogTitle?: string
  dialogContents?: string
  disabled?: boolean
}

const DEFAULT_CONTENTS =
  "You're about to finalize the note, and it will become a formal, uneditable part of the chart. Are you sure you want to proceed?"

const ConfirmNoteDialog = ({
  isSubmitting,
  onSubmit,
  buttonLabel,
  dialogTitle,
  dialogContents,
  disabled = false,
}: Props) => {
  const ref = useScrollToFirstError<HTMLButtonElement>()
  return (
    <ConfirmationDialog
      onProceed={onSubmit}
      title={dialogTitle ?? 'Complete Intake Note'}
      contents={dialogContents ?? DEFAULT_CONTENTS}
    >
      {(open) => (
        <Button
          ref={ref}
          color="primary"
          disabled={isSubmitting || disabled}
          onClick={open}
          variant="contained"
          style={{ marginTop: '16px' }}
        >
          {buttonLabel ?? 'Intake note is complete'}
        </Button>
      )}
    </ConfirmationDialog>
  )
}

export default ConfirmNoteDialog
